<template>
	<div style="padding: 0 10px;box-sizing: border-box;">
    	<el-row :gutter="20" style="margin-right:0;margin-top: 10px;">
      		<el-col :span="4">
        		<div class="grid-contents bg-purple">
          			<el-tree ref="tree" :data="deptTree" node-key="phoneNumber" :highlight-current="true" default-expand-all :expand-on-click-node="false" @node-click="deptNodeClick">
            			<span class="custom-tree-node" slot-scope="{ node, data }">
							<span>
                				<span v-if="data.type == 'user'">
									<i class="el-icon-user-solid"></i>
								</span>
                				<span v-else>
									<i class="el-icon-folder"></i>
								</span>
								{{ node.label }}
							</span>
              				<span v-if="data.count > 0">
                				<el-badge :value="data.count" class="item"></el-badge>
              				</span>
            			</span>
        			</el-tree>
        		</div>
      		</el-col>
      		<el-col :span="20">
				<div class="grid-contents">
					<el-tabs v-model="activeName" @tab-click="handleTabClick">
						<el-tab-pane name="0" label="待处理">
							<el-button size="mini" :type="multipleSelectionML.length==0?'info':'primary'" @click="changeAuditBatch" style="margin-bottom: 10px;">批量审核</el-button>
							<el-table ref="tableClass" :cell-class-name="setTabClass" @expand-change="handleExpendRow" :row-key='getRowKeys' :expand-row-keys="expands" @cell-click="cellClickTab" @selection-change="handleSelectionChangeML" :header-cell-style="{fontSize: '14px', backgroundColor: '#f8f8f8',color:'#606266',height:'54px'}" size="mini" border :data="processTableInfo.rows" style="width: 100%" :loading="processTableInfo.loading" height="630px" :highlight-current-row="true" @row-click="proceeRowClick">
								<el-table-column type="selection" width="55"></el-table-column>
								<el-table-column type="expand" width="1">
									<template slot-scope="props">
										<div class="tableBack">
											<el-table :header-cell-style="{fontSize: '14px', backgroundColor: 'rgba(187,252,155,0.3)',color:'#606266',height:'45px'}" :data="props.row.invoiceList" size="mini"  @cell-click="cellClick" :highlight-current-row="true" :cell-class-name="setClass" style="width: 100%">
												<el-table-column prop="invoiceType" label="发票类型" width="100" show-overflow-tooltip></el-table-column>
												<el-table-column prop="fphm" label="发票号" width="220" show-overflow-tooltip> </el-table-column>
												<el-table-column prop="xfmc" label="开票单位" width="320"  show-overflow-tooltip> </el-table-column>
												<el-table-column prop="jshj" align="right" label="金额" width="120" show-overflow-tooltip> 
													<template slot-scope="scope"> {{ formatRMBExec(scope.row) }}</template>
												</el-table-column>
												<el-table-column prop="gfmc" label="付款人" width="360" show-overflow-tooltip> </el-table-column>
												<el-table-column prop="kprq" label="开票日期"  width="120" show-overflow-tooltip> </el-table-column>
												<el-table-column prop="type" label="票别" width="180" show-overflow-tooltip> </el-table-column>
												<el-table-column prop="verifyStatus" label="验真状态" show-overflow-tooltip>
													<template slot-scope="scope">
														<span style="color: #67c23a;" v-if="scope.row.verifyStatus == '验真成功'">验真成功</span>
														<span style="color: gold;" v-else-if="scope.row.verifyStatus == '未验真'">未验真</span>
														<span style="color: red;" v-else-if="scope.row.verifyStatus == '验真失败'">验真失败</span>
														<span style="color: #ccc;" v-else-if="scope.row.verifyStatus == '不支持验真'">不支持验真</span>
													</template>
												</el-table-column>
											</el-table>
										</div>
									</template>
								</el-table-column>
								<el-table-column width="160" prop="createTime" label="提交日期" show-overflow-tooltip></el-table-column>
								<el-table-column width="750" prop="title" label="报销事由" show-overflow-tooltip> </el-table-column>
								<el-table-column  width="80" align="center" prop="count" label="发票数量" show-overflow-tooltip>
									<template slot-scope="scope">{{ scope.row.count }}</template>
								</el-table-column>
								<el-table-column width="120" prop="amount" label="合计金额" show-overflow-tooltip>
									<template slot-scope="scope"> {{ formatRMBAmountExec(scope.row.amount)}}</template>
								</el-table-column>
								<el-table-column width="80" prop="fullName" label="提交人" show-overflow-tooltip> </el-table-column>
								<el-table-column width="120" prop="phone" label="联系电话" show-overflow-tooltip> </el-table-column> 
								<el-table-column label="操作"> 
									<template slot-scope="scope">
										<el-button @click="changeIndex(scope.$index,scope.row)" type="text" size="small">审核确认</el-button>
										<el-button @click="returnProcess(scope.row,scope.$index)" type="text" size="small">退回</el-button>
										<el-button type="text" size="small" @click="changeVerifyBatch(scope.row)">发票验真</el-button>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination style="float: right;margin-top: 10px;" layout="prev,pager,next" @current-change="changeProcessPage" :total="processTableInfo.total"></el-pagination>  </el-tab-pane>
						<el-tab-pane name="1" label="已处理">
              <el-row :gutter="24" style="margin-right: 0;">
                <el-col :span="10">
                  <el-form :inline="true" size="small" :model="formObj">
                    <el-form-item label="会计月份">
                      <el-date-picker format="yyyy-MM" value-format="yyyy-MM" v-model="formObj.accountingDate" type="month" placeholder="选择月"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="报销人">
                      <el-input  placeholder="报销人" v-model="formObj.fullName"></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="2">
                  <el-button size="small" type="primary" @click="listProcessFunc" ><i class="el-icon-search"></i> 查询</el-button>
                </el-col>
              </el-row>
							<el-table :cell-class-name="setTabClass" @expand-change="handleExpendRow" :row-key='getRowKeys' :expand-row-keys="expands" @cell-click="cellClickTab" @selection-change="handleSelectionChangeML" :header-cell-style="{fontSize: '14px', backgroundColor: '#f8f8f8',color:'#606266',height:'54px'}" size="mini" border :data="processTableInfo.rows" style="width: 100%" :loading="processTableInfo.loading" height="600px" :highlight-current-row="true" @row-click="proceeRowClick">
								<el-table-column type="expand" width="1">
									<template slot-scope="props">
										<div class="tableBack">
											<el-table :header-cell-style="{fontSize: '14px', backgroundColor: 'rgba(187,252,155,0.3)',color:'#606266',height:'45px'}" :data="props.row.invoiceList" size="mini"  @cell-click="cellClick" :highlight-current-row="true" :cell-class-name="setClass" style="width: 100%">
												<el-table-column prop="invoiceType" label="发票类型" width="100" show-overflow-tooltip></el-table-column>
												<el-table-column prop="fphm" label="发票号" width="200" show-overflow-tooltip> </el-table-column>
												<el-table-column prop="xfmc" label="开票单位" width="300"  show-overflow-tooltip> </el-table-column>
												<el-table-column prop="jshj" align="right" label="金额" width="120" show-overflow-tooltip> 
													<template slot-scope="scope"> {{ formatRMBExec(scope.row) }}</template>
												</el-table-column>
												<el-table-column prop="gfmc" label="付款人" width="340" show-overflow-tooltip> </el-table-column>
												<el-table-column prop="kprq" label="开票日期"  width="120" show-overflow-tooltip> </el-table-column>
												<el-table-column prop="type" label="票别" width="160" show-overflow-tooltip> </el-table-column>
												<el-table-column prop="verifyStatus" label="验真状态" show-overflow-tooltip>
													<template slot-scope="scope">
														<span style="color: #67c23a;" v-if="scope.row.verifyStatus == '验真成功'">验真成功</span>
														<span style="color: gold;" v-else-if="scope.row.verifyStatus == '未验真'">未验真</span>
														<span style="color: red;" v-else-if="scope.row.verifyStatus == '验真失败'">验真失败</span>
														<span style="color: #ccc;" v-else-if="scope.row.verifyStatus == '不支持验真'">不支持验真</span>
													</template>
												</el-table-column>
											</el-table>
										</div>
									</template>
								</el-table-column>
								<el-table-column width="160" prop="createTime" label="提交日期" show-overflow-tooltip></el-table-column>
								<el-table-column width="420" prop="title" label="报销事由" show-overflow-tooltip> </el-table-column>
								<el-table-column  width="80" align="center" prop="count" label="发票数量" show-overflow-tooltip>
									<template slot-scope="scope">{{ scope.row.count }}</template>
								</el-table-column>
								<el-table-column width="120" align="right" prop="amount" label="合计金额" show-overflow-tooltip>
									<template slot-scope="scope"> {{ formatRMBAmountExec(scope.row.amount)}}</template>
								</el-table-column>
								<el-table-column width="80" prop="fullName" label="报销人" show-overflow-tooltip> </el-table-column>
								<el-table-column width="120" prop="phone" label="联系电话" show-overflow-tooltip> </el-table-column> 
								<el-table-column width="120" prop="updateBy" label="审核人" show-overflow-tooltip> </el-table-column> 
								<el-table-column width="160" prop="updateTime" label="审核时间" show-overflow-tooltip> </el-table-column>
                				<el-table-column width="100" prop="accountingDate" label="会计月份" show-overflow-tooltip> </el-table-column>
								<el-table-column width="120" prop="remarks" label="凭证号" show-overflow-tooltip> </el-table-column>  
								<el-table-column label="操作"> 
									<template slot-scope="scope">
										<el-button  @click="settingUnReimbursedFunc(scope.row,'batch',scope.$index)" type="text" size="small">取消报销</el-button>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination style="float: right;margin-top: 10px;" layout="prev,pager,next" @current-change="changeProcessPage" :total="processTableInfo.total"></el-pagination>  
						</el-tab-pane>
						<el-tab-pane name="2" label="未提交">
							<el-table :header-cell-style="{fontSize: '14px', backgroundColor: '#f8f8f8',color:'#606266',height:'54px'}"  border  :data="unitAllInvoic.tableData" style="width: 100%" height="650px" size="mini" stripe>
								<el-table-column prop="invoiceType" label="发票类型" width="100" show-overflow-tooltip></el-table-column>
								<el-table-column prop="fphm" label="发票号" width="200" show-overflow-tooltip> </el-table-column>
								<el-table-column prop="xfmc" label="开票单位" width="300"  show-overflow-tooltip> </el-table-column>
								<el-table-column prop="jshj" label="金额" width="120" show-overflow-tooltip> 
									<template slot-scope="scope"> {{ formatRMBExec(scope.row) }}</template>
								</el-table-column>
								<el-table-column prop="gfmc" label="付款人" width="300" show-overflow-tooltip></el-table-column>
								<el-table-column prop="kprq" label="开票日期"  width="120" show-overflow-tooltip></el-table-column>
								<el-table-column prop="type" label="票别" width="160" show-overflow-tooltip></el-table-column>
								<el-table-column prop="verifyStatus" label="验真状态" show-overflow-tooltip></el-table-column>
								<el-table-column prop="address" label="操作" fixed="right" width="90"> 
									<template slot-scope="scope">
										<el-button @click="showImageClick(scope.row)" type="text" size="small">查看</el-button>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination style="float: right;margin-top: 10px;" :page-sizes="unitAllInvoic.pages" layout="sizes,prev,pager,next" @current-change="changeInvoicePage" @size-change="changeInvoiceSize" :total="unitAllInvoic.count"></el-pagination>
						</el-tab-pane>
					</el-tabs>
				</div>
      		</el-col>
    	</el-row>
	<el-dialog center :title="detailTitle" top="2vh" :visible.sync="dialogVisible" width="70%" @open="open" @close="close">
    	<div>
        	<el-row :gutter="20">
          		<el-col :span="4">
            		<div class="grid-content bg-purple grid_box">
              			<div :class="active==index?'grid_box_list active':'grid_box_list'" @click="changeList(item,index)" v-for="(item,index) in detailTableList" :key="index">{{item.invoiceType}}-{{item.fphm}}</div>
            		</div>
          		</el-col>
          		<el-col :span="20">
            		<div class="grid-content bg-purple">
              			<el-image  class="bg-contain" :src="imagesSrc[active]" style="width: 100%;height: 600px;object-fit: contain;" :preview-src-list="imagesSrc"></el-image>
            		</div>
          		</el-col>
        	</el-row>
	  		<div style="text-align: center;margin-top: 20px;">
          <el-form ref="form" :inline="true" :model="form" label-width="100px">
            <el-form-item label="会计月份">
              <el-date-picker :default-value="defaultMonth" format="yyyy-MM" value-format="timestamp" v-model="formData.accountingDate" type="month" placeholder="选择月"></el-date-picker>
            </el-form-item>
            <el-form-item label="报销凭证号">
              <el-input v-model="formData.title" placeholder="请输入报销凭证号"></el-input>
            </el-form-item>
          </el-form>
	  		</div>
      	</div>
      	<span slot="footer" class="dialog-footer">
        	<el-button type="success" @click="settingReimbursedFunc(processTableInfo.rows[acIndex],'batch')">审核通过</el-button>
        	<el-button type="danger" @click="returnProcess(processTableInfo.rows[acIndex],acIndex)">审核不通过</el-button>
        	<el-button @click="dialogVisible = false">取消</el-button>
      	</span>
    </el-dialog>
    <el-dialog title="提示" width="30%" :visible.sync="dialogTabVisible">
		<div style="display: flex;align-items: center;">
			<i class="el-icon-warning" style="font-size: 24px;color: #e6a23c;margin-right: 10px"></i>
			<span style="font-size: 16px;" v-if="rowObj.verifyStatus=='验真成功'">此发票已于{{rowObj.verifyTime}}进行验真操作并通过。</span>
			<span style="font-size: 16px;" v-if="rowObj.verifyStatus=='验真失败'">此发票已于{{rowObj.verifyTime}}进行验真操作，未通过验真。</span>
			<span style="font-size: 16px;" v-if="rowObj.verifyStatus=='未验真'">此发票符合验真条件，需要提交验真吗？</span>
			<span style="font-size: 16px;" v-if="rowObj.verifyStatus=='不支持验真'">此票据不符合目前验真条件，无法进行在线验真。</span>
		</div>
      	<span slot="footer" class="dialog-footer">
        	<el-button @click="colseDialog">取消({{ second }})</el-button>
        	<el-button v-if="rowObj.verifyStatus=='验真失败'" @click="yzinvoiceVerify(true)" type="primary">再次验真</el-button>
        	<el-button v-if="rowObj.verifyStatus=='未验真'" @click="yzinvoiceVerify(false)" type="primary">提交验真</el-button>
      	</span>
    </el-dialog>
     <!-- 查看 -->
    <el-dialog title="批量审核" center :visible.sync="showAuditBatchVisible" width="600px" destroy-on-close>
		<el-form ref="form" :model="form" label-width="100px">
	  		<el-form-item label="会计月份">
				<el-date-picker :default-value="defaultMonth" format="yyyy-MM" value-format="timestamp" v-model="form.accountingDate" type="month" placeholder="选择月"></el-date-picker>
	  		</el-form-item>
	  		<el-form-item label="报销凭证号">
				  <el-input v-model="form.titleName" placeholder="请输入报销凭证号"></el-input>
	  		</el-form-item>
        <el-form-item label="退回原因说明">
				  <el-input v-model="form.returnReason" placeholder="请输入退回原因说明"></el-input>
	  		</el-form-item>
		</el-form>
      	<span slot="footer" class="dialog-footer">
        	<el-button type="success" @click="settingReimbursedFuncML('reimbursed')">审核通过</el-button>
        	<el-button type="danger" @click="settingReimbursedFuncML('return')">审核不通过</el-button>
        	<el-button @click="showAuditBatchVisible = false">取消</el-button>
      	</span>
    </el-dialog>
    <el-dialog title="查看发票" :visible.sync="showImagesVisible" width="800" destroy-on-close>
    	<el-empty v-if="showImagesSrc == null || showImagesSrc == ''" description="无数据"></el-empty>
      	<el-image style="height: 560px;width: 100%;" :src="showImagesSrc" fit="fill"></el-image>
    </el-dialog>
</div>
</template>

<script>
import { getInfo } from "@/cookie";
import { formatRMB } from "@/utils/kits";
import { processInvoiceList , mimeInvoiceList,updateType,deleteMimeInvoice,invoiceVerify,verifyBatch } from "@/api/invoice";
import { findInvoiceTypes,findNormalTags } from "@/api/dict";
import { treeUnitDept,} from "@/api/dept";
import { listProcess , settingReimbursed , settingUnReimbursed , settingReturn, auditBatch } from "@/api/process";
import { Message, MessageBox } from 'element-ui';

export default {
  name: "InvoiceLedger",
  data() {
    return {
	formData:{
		title:'',
		accountingDate:'',
    returnReason:''
	},
	defaultMonth:'',
      rowObj:{},
      dialogTabVisible:false,
      timer:null,
      second:3,
      total:0,
      moveBy:0,
      getRowKeys(row) {
        return row.id;
      },
      formObj:{
        accountingDate:'',
        fullName:''
      },
	    form:{
        titleName:'批量审核',
        accountingDate:'',
        returnReason:''
      },
      expands: [],
      showAuditBatchVisible:false,
      multipleSelection:[],
      multipleSelectionML:[],
      acIndex:0,
      active:0,
      title:'',
      imagesSrc:[],
      dialogVisible:false,
      activeName:'0',
      query: {
        title: "",
        fullName: "",
        phoneNumber: "",
        deptId : '',
      },
      tableData: [],
      tablePage : {
        pageNum: 1,
        pageSize: 10,
        status: '',
        tableCount: 50,
        pageSizeList: [10,20]
      },

      deptTree : [],

      processTableInfo : {
        loading: false,
        selectorRowId:'',
        pageNum: 1,
        pageSize: 10,
        total: 0,
        rows: [],
      },
      detailTitle:'',
      detailProcessId:'',
      detailTableList:[],

      showUploadInvoiceDialog: false,
      showImagesVisible : false,
      showImagesSrc : null,

      unitAllInvoic : {
        tableData: [],
        pages:[10,20],
        count: 0,
        pageNum:0,
        pageSize:10
      }

    };
  },
  created() {
    this.keyDown()
    let info_ = getInfo();
    this.userInfo = {...info_};
    this.getTreeDepts();
    this.listProcessFunc();
  },
  mounted(){
	this.form.accountingDate=new Date().getTime();
	this.formData.accountingDate=new Date().getTime();
  },
  beforeDestroy () {
    this.keyDownReview()
  },
  methods: {
    colseDialog(){
      this.dialogTabVisible=false
      clearInterval(this.timer)
    },
    handleExpendRow(row, expandedRows){
      if (expandedRows.length) {
        this.expands = [];
        if (row) {
          this.expands.push(row.id);
        }
      }else{
        this.expands = [];
      }
      this.$nextTick(()=>{
        this.$refs.tree.setCurrentKey(row.phone)
      })
      this.detailProcessId = row.id;
      // this.listDetailInvoices(row.id);
    },
    changeAuditBatch(){
      if(this.multipleSelectionML.length==0){
        Message.error('请勾选要审批确认的发票!');
        return false
      }
      this.showAuditBatchVisible=true;
    },
    changeVerifyBatch(row){
      let invoiceList=row.invoiceList
      let invoiceIds =[]
      invoiceList.map((item)=>{
        if(item.verifyStatus=='验真失败' || item.verifyStatus=='未验真'){
          invoiceIds.push(item.id)
        } 
      })
      if(invoiceList.length==0 || invoiceIds.length==0){
        Message.error('没有要验真的发票!');
        return false
      }
      verifyBatch({invoiceIds}).then((res)=>{
        if(res.code==200){
          Message.success(res.msg);
		  this.listProcessFunc(true,0);
        }else{
          Message.success(res.msg);
        }
      })
    },
    handleSelectionChangeML(val){
      this.multipleSelectionML = val;
    },
    changeIndex(index,res){
	this.detailTableList = res.invoiceList;
	this.total=res.invoiceList.length
	this.title=this.detailTableList[0].invoiceType+'-'+this.detailTableList[0].fphm;
	this.imagesSrc=[]
	this.detailTableList.forEach(row => {
	let src = row.fileId ? ('https://cloud.themis.com.cn/api/common/image/preview?fileId=' + row.fileId) : (row.valueCode ? ('https://cloud.themis.com.cn/api/common/image/preview?checksum=' + row.valueCode) : null);
	this.imagesSrc.push(src)
	});
      this.acIndex=index
      this.dialogVisible=true
    },
    //格式化金额
    formatRMBAmountExec(amount){
        return formatRMB(amount);
    },
    close(){
      this.active=0
    },
    keyDown () {
      document.onkeydown = e => {
        //112表示F1键
        if (e.keyCode === 40) {
          if(this.detailTableList.length !=this.active+1){
            this.active++
          }
          let row =this.detailTableList[this.active]
          this.changeList(row,this.active)
          //取消原来的后续事件
          e.preventDefault()
        }else if(e.keyCode === 38){
          if(this.active!=0){
            this.active--
          }
          let row =this.detailTableList[this.active]
          this.changeList(row,this.active)
        }
      }
    },
    keyDownReview () {
      document.onkeydown = function (event) {
        var e = event || window.event;
        e.returnValue = true;
      }
    },
    changeList(row,index){
      this.active=index
      this.title=row.invoiceType+'-'+row.fphm;
      // let processId=row.id
      // let url = window.location.origin;
      // let src = row.fileId ? ('https://cloud.themis.com.cn/api/common/image/preview?fileId=' + row.fileId) : (row.valueCode ? ('https://cloud.themis.com.cn/api/common/image/preview?checksum=' + row.valueCode) : null);
      // this.imagesSrc.push(src)
      // processInvoiceList({processId:processId}).then(res => {
      //     let url = window.location.origin;
      //     this.imagesSrc=[]
      //     res.data.forEach(row => {
      //       let src = row.fileId ? ('https://cloud.themis.com.cn/api/common/image/preview?fileId=' + row.fileId) : (row.valueCode ? ('https://cloud.themis.com.cn/api/common/image/preview?checksum=' + row.valueCode) : null);
      //       this.imagesSrc.push(src)
      //     });
      // });
    },
    open(){
      // let row =this.processTableInfo.rows[0]
      // let processId=row.id
      // this.title=row.createTime+'-'+row.amount+'-'+row.fullName
      // processInvoiceList({processId:processId}).then(res => {
      //     let url = window.location.origin;
      //     this.imagesSrc=[]
      //     res.data.forEach(row => {
      //       let src = row.fileId ? ('https://cloud.themis.com.cn/api/common/image/preview?fileId=' + row.fileId) : (row.valueCode ? ('https://cloud.themis.com.cn/api/common/image/preview?checksum=' + row.valueCode) : null);
      //       this.imagesSrc.push(src)
      //     });
      // });
    },
    cellClickTab(row, column, cell, event){
      if(column.property=='count'){
        this.$refs.tableClass.toggleRowExpansion(row);
      }
    },
    cellClick(row, column, cell, event){
      if(column.property=='fphm'){
        this.showImageClick(row)
      }else if(column.property=='verifyStatus' && this.activeName=='0'){
         this.yzexec(row)
      }
    },
    setTabClass({ row, column, rowIndex, columnIndex }){
      if(column.property=='count'){
        return 'addBorder'
      }
    },
    setClass({ row, column, rowIndex, columnIndex }) {
      if(column.property=='fphm'){
        return 'addBorder'
      }else if(column.property=='verifyStatus'){
         return 'addBorder'
      }
    },
    //格式化金额
    formatRMBExec(row){
        let je = row.vatInvoiceTotalCoverTaxDigits;
        if(je == null || je == ''){
           je = row.jshj;
        }
        return formatRMB(je);
    },

    //单位部门
    getTreeDepts(){
      treeUnitDept({processed:true,showUser:true}).then(res => {
          this.deptTree = res.data;
      });
    },

    //点击部门
    deptNodeClick(val){
      if(val.type == 'user'){
        this.query.deptId = '';
         this.query.phoneNumber = val.phoneNumber;
      } else {
         this.query.deptId = val.id;
         this.query.phoneNumber = null;
      }
      if(this.activeName == '2'){
        this.getUnitInvoicePage();
      } else {
        this.listProcessFunc(true,0);
        // listDetailInvoices
      }
    },
    //页码
    changeProcessPage(val1){
      this.processTableInfo.pageNum = val1;
      this.listProcessFunc();
    },
    //处理消息
    listProcessFunc(flag,index){
      this.processTableInfo.rows  = [];
      // this.processTableInfo.total = 0;
      this.processTableInfo.loading = true;  
      let where = this.processTableInfo;
          where.status = this.activeName;
          where.title = this.query.title;
          where.phoneNumber = this.query.phoneNumber;
          where.deptId = this.query.deptId;
		  where.accountingDate=this.formObj.accountingDate
		  where.fullName=this.formObj.fullName
      this.detailTableList = [];  
      listProcess(where).then(res => {
         this.processTableInfo.rows  = res.data.rows;
         if(flag && this.processTableInfo.rows.length>0){
          let num=index==0?index:index-1
          let row=this.processTableInfo.rows[num]
          this.$refs.tableClass.setCurrentRow(row, true);
          this.detailTitle = '【'+ row.fullName+'】' +row.title;
          this.detailProcessId = row.id;
      //     this.listDetailInvoices(row.id);
         }else{
          this.detailTitle=''
         }
         this.processTableInfo.total = res.data.total;
          this.open()
         this.processTableInfo.loading = false;  
      });
    },
    //切换类型
    handleTabClick(val){
      this.$nextTick(()=>{
        this.getTreeDepts()
        this.detailTitle=''
        
      })
      if(val.index == '2'){
        this.getUnitInvoicePage();
      } else if(val.index =='1'){
		var today = new Date();
		var year = today.getFullYear();
		var month = today.getMonth() + 1; // 月份是从 0 开始计数的，需要加1
		var formattedTime = year + "-" + (month < 10 ? "0" : "") + month
		this.formObj.accountingDate=formattedTime
		this.formObj.fullName=''
        this.listProcessFunc(true,0);
      }else{
		this.formObj.accountingDate=''
		this.formObj.fullName=''
		this.listProcessFunc(true,0);
	  }
    },

    //点击消息
    proceeRowClick(row){
      this.$nextTick(()=>{
        this.$refs.tree.setCurrentKey(row.phone)
      })
      this.detailTitle = '【'+ row.fullName+'】' +row.title;
      this.detailProcessId = row.id;
      // this.listDetailInvoices(row.id);
    },

    //获取数据
//     listDetailInvoices(processId){
//       processInvoiceList({processId:processId}).then(res => {
//           this.detailTableList = res.data;
//           this.total=res.data.length
//           this.title=this.detailTableList[0].invoiceType+'-'+this.detailTableList[0].fphm;
//           this.imagesSrc=[]
//           this.detailTableList.forEach(row => {
//             let src = row.fileId ? ('https://cloud.themis.com.cn/api/common/image/preview?fileId=' + row.fileId) : (row.valueCode ? ('https://cloud.themis.com.cn/api/common/image/preview?checksum=' + row.valueCode) : null);
//             this.imagesSrc.push(src)
//           });
//       });
//     },
    settingReimbursedFuncML(type){
      if(this.multipleSelectionML.length==0){
        Message.error('请勾选要审批确认的发票!');
        return false
      }
      if(this.form.titleName=='' && type=='reimbursed'){
        Message.error('请输入报销凭证号!');
        return false
      }
	  if(this.form.returnReason=='' && type=='return'){
        Message.error('请输入退回原因说明!');
        return false
      }
      let processId= this.multipleSelectionML.map((item)=>item.id)
      let parmas={
        title:this.form.titleName,
		returnReason:this.form.returnReason,
	  	accountingDate:this.form.accountingDate,
        processId: processId.join(', '),
        tagCode:type,
        settingAll:type == 'reimbursed' ? true : false
      }
      auditBatch(parmas).then((res)=>{
        if(res.code == 200){
          Message.success('操作成功');
          this.showAuditBatchVisible=false
          this.form.titleName='批量审核'
          this.listProcessFunc(true,this.acIndex)
        }else{
          Message.error(res.msg);
        }
      })
    },
    //设置发票标签
    settingReimbursedFunc(row,type){
		if(this.formData.title==''){
			Message.error('请输入报销凭证号!');
			return false
		}
		let msg = type == 'batch' ? '是否确定将该批次发票标记为已报销？' : '是否确定将该发票标记为已报销？';
		let processId = type == 'batch' ? row.id : this.detailProcessId;
		MessageBox.confirm(msg, '提示', { confirmButtonText: '确定', cancelButtonText: '取消',type: 'warning'}).then(() => {
			let where = {
			  title:this.formData.title,
			  accountingDate:this.formData.accountingDate,
			  processId: processId,
			  invoiceId: type == 'batch' ? null : row.id,
			  tagCode: 'reimbursed',
			  settingAll: type == 'batch' ? true : false
			}
			settingReimbursed(where).then(res => {
				if(res.code == 200){
				  Message.success('操作成功');
				  this.dialogVisible=false
				  this.formData.title=''
				  this.formData.accountingDate=new Date().getTime();
				  this.listProcessFunc(true,this.acIndex);
				}else{
					Message.error(res.msg);
					this.dialogVisible=false
					this.formData.title=''
					this.formData.accountingDate=new Date().getTime();
				}
			})
		})
        // let this_ = this;
        // let msg = type == 'batch' ? '是否确定将该批次发票标记为已报销？' : '是否确定将该发票标记为已报销？';
        // let processId = type == 'batch' ? row.id : this.detailProcessId;
        // MessageBox.prompt('请输入报销凭证号', '提示', { confirmButtonText: '确定', cancelButtonText: '取消',inputPattern:/^[\s\S]*.*[^\s][\s\S]*$/, inputErrorMessage: '凭证号不能为空'}).then(({value} ) => {
        //     let where = {
        //       title:value,
        //       processId: processId,
        //       invoiceId: type == 'batch' ? null : row.id,
        //       tagCode: 'reimbursed',
        //       settingAll: type == 'batch' ? true : false
        //     }
        //     settingReimbursed(where).then(res => {
        //         if(res.code == 200){
        //           Message.success('操作成功');
        //           this.dialogVisible=false
        //           if(type == 'batch'){
        //             this_.listProcessFunc(true,this.acIndex);
        //           } else {
        //           //   this_.listDetailInvoices(processId);
        //           }
        //         } else {
        //           Message.error(res.msg);
        //         }
        //     });
        // }).catch(() => {
                   
        // });
    },

    //取消标记
    settingUnReimbursedFunc(row,type,index){
        let this_ = this;
        let msg = type == 'batch' ? '是否确定要取消该批次的发票标记吗？' : '是否确定将该发票标记为已报销？';
        let processId = type == 'batch' ? row.id : this.detailProcessId;
        MessageBox.confirm(msg, '提示', { confirmButtonText: '确定', cancelButtonText: '取消',type: 'warning'}).then(() => {
            let where = {
              processId: processId,
              invoiceId: type == 'batch' ? null : row.id,
              tagCode: 'reimbursed',
              settingAll: type == 'batch' ? true : false
            }
            settingUnReimbursed(where).then(res => {
                if(res.code == 200){
                  Message.success('操作成功');
                  if(type == 'batch'){
                    this_.listProcessFunc(true,index);
                  } else {
                  //   this_.listDetailInvoices(processId);
                  }
                } else {
                  Message.error(res.msg);
                }
            });
        }).catch(() => {});
    },

    //查看附件
    showImageClick(row){
        let url = window.location.origin;
        let src = row.fileId ? (url + '/api/common/image/preview?fileId=' + row.fileId) : (row.valueCode ? (url + '/api/common/image/preview?checksum=' + row.valueCode) : null);
        this.showImagesVisible = true;
        this.showImagesSrc = src;
    },
    timeOut(){
        this.second=3
				this.timer = setInterval(() => {
          if (this.second <= 0) {
            if (this.timer) clearInterval(this.timer)
            this.second=4
            this.dialogTabVisible=false
            return
          }
          this.second--

				},1000)
			},
    yzinvoiceVerify(flag){
      invoiceVerify(this.rowObj.id,flag).then(res => {
          if(res.code == 200 ){
              Message.success(res.msg);
              this.dialogTabVisible=false
              clearInterval(this.timer)
              this.listProcessFunc();
          } else {
              Message.error(res.data.reason);
              this.dialogTabVisible=false
              clearInterval(this.timer)
          }
      });
    },
    //发票验真
    yzexec(row){
      this.rowObj=row
      this.dialogTabVisible=true
      this.timeOut()
    },

     //退回
    returnProcess(row,index){
        let this_ = this;
        let processId = row.id;
        MessageBox.prompt('是否确定要退回该批次,确定后将不可撤销？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消',inputValidator:(value)=>{if(value){return true}else{return '请输入退回原因说明'}},inputPlaceholder:'请输入退回原因说明',type: 'warning'}).then((res) => {
            let where = {processId: processId,tagCode:'return',returnReason:res.value}
            settingReturn(where).then(res => {
                if(res.code == 200){
                  this.dialogVisible=false
                  Message.success('操作成功');
                  this_.listProcessFunc(true,index);
                } else {
                  Message.error(res.msg);
                }
            });
        }).catch(() => {});
    },

    //切换页码
    changeInvoicePage(num){
        this.unitAllInvoic.pageNum = num;
        this.getUnitInvoicePage();
    },
    //切换页数
    changeInvoiceSize(num){
        this.unitAllInvoic.pageSize = num;
        this.getUnitInvoicePage();
    },
    //单位发票
    getUnitInvoicePage(){
      let param = {...this.unitAllInvoic};
          param.deptId = this.query.deptId;
          param.phone = this.query.phoneNumber;
          param.notSubmit = true;
          param.allQuery = true;
      //都不存在    
      if(!param.deptId && !param.phone){
          if(this.deptTree.length > 0){
             param.deptId = this.deptTree[0].id;
          }
      }
      mimeInvoiceList(param).then(res => {
          this.unitAllInvoic.tableData = res.data.page.content;
          this.unitAllInvoic.count = res.data.page.totalElements;
      });
    }

  },
};
</script>

<style>
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
  color: #026abe;
}
.active{
  color: #026abe;
}
.el-dialog__body{
	padding: 25px 25px 0px !important;
}
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
    font-size: 15px;
    padding-right: 8px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #ccc;
  }
  .bg-purple {
   border: 1px solid #ccc;
   padding: 10px;
   box-sizing: border-box;
  }
  .bg-purple-light {
    /* background: #e5e9f2; */
  }
  .grid-contents {
    border-radius: 4px;
    height: 765px;
	overflow-y: auto;
  }
  
::-webkit-scrollbar-thumb {
  background-color: #9e9e9e; /* 定制滑块颜色 */
  border-radius: 5px; /* 定制滑块边角的圆滑程度 */
}
::-webkit-scrollbar {
  width: 10px; /* 定义滚动条的宽度 */
  background-color: #f5f5f5; /* 定义滚动条轨道的背景颜色 */
}
  .grid-content {
    border-radius: 4px;
    min-height: 650px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #fafcf9;
  }
  .bg-purpleML{
    background: #e5e9f2;
    height: 35px;
    line-height: 35px;
    padding: 0px 20px;
    box-sizing: border-box;
  }
  .addBorder div{
    color: #409eff !important;
    /* text-decoration: underline; */
    cursor: pointer;
  }
  .el-table th{
    font-size: 16px;
    height: 48px;
  }
  .el-table tr{
    font-size: 16px;
    height: 48px;
  }
.custom-table-row {
  height: 48px; /* 你想要设置的列高度 */
}
.el-table__row .current-row{
  height: 48px;
}
.grid_box{
  font-weight: bold;
  padding: 20px;
  box-sizing: border-box;
}
.grid_box_list{
  line-height: 25px;
  font-size: 14px;
  cursor: pointer;
}
.bg-contain{
  img{
   object-fit: contain;
  }
}
/* 自定义滚动条的样式 */
.el-table__body-wrapper::-webkit-scrollbar {
  width: 6px; /* 设置滚动条的宽度 */
}
 
.el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 3px; /* 滚动条的圆角 */
  background: rgba(0,0,0,.2); /* 滚动条的背景色 */
}
 
.el-table__body-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1); /* 滚动条轨道的阴影效果 */
  background-color: #f0f0f0; /* 滚动条轨道的背景色 */
}
 
/* 针对Firefox的滚动条样式 */
.el-table__body-wrapper {
  scrollbar-width: thin; /* 设置滚动条宽度 */
  scrollbar-color: rgba(0,0,0,.2) #f0f0f0; /* 滚动条的颜色 */
}

.tableBack{
  background-color: #eeffe6;
  padding: 0 10px;
  box-sizing: border-box;
}
.tableBack .el-table tbody tr>td{
    background-color: rgba(187,252,155,0.3);
}
</style>


// WEBPACK FOOTER //
// src/views/components/InvoiceLedger.vue